import { useState } from "react";
import styles from "./AddMovieForm.module.css";
import { nanoid } from "nanoid";
import Alert from "../Alert/Alert";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addMovie } from "../../features/moviesSlice";

function AddMovieForm(props) {
  // Desctructing Props: state movies
  const { movies, setMovies } = props;
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // membuat state object
  const [formData, setFormData] = useState({
    title: "",
    date: "",
    image: "",
    genre: "",
  });

  // membuat state object error
  const [formError, setFormError] = useState({
    isTitleError: false,
    isDateError: false,
    isImageError: false,
    isGenreError: false,
  });

  // membuat fungsi handlechange untuk handle semua input form
  function handlechange(e) {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  }

  // Destructing state formData
  const { title, date, image, genre } = formData;

  // membuat fungsi validasi form
  function validate(e) {
    if (title === "") {
      setFormError({ title: true });
      return false;
    } else if (date === "") {
      setFormError({ date: true, title: false });
      return false;
    } else if (image === "") {
      setFormError({ image: true, date: false });
      return false;
    } else {
      setFormError({
        title: false,
        date: false,
        image: false,
        genre: false,
      });
      return true;
    }
  }

  function SubmitMovie() {
    const movie = {
      id: nanoid(),
      title: title,
      year: date,
      type: genre,
      poster: image,
    };

    dispatch(addMovie(movie));
    navigation("/");
  }

  function handleSubmit(e) {
    e.preventDefault();

    validate() && SubmitMovie();
  }

  return (
    <div className={styles.container}>
      <section className={styles.form}>
        <div className={styles.form__left}>
          <img
            className={styles.form__image}
            src="https://picsum.photos/536/354"
            alt="placeholder"
          />
        </div>
        <div className="styles.form__right">
          <h2 className={styles.form__title}>Add Movie</h2>
          <form onSubmit={handleSubmit} className={styles.form__action}>
            <label className={styles.form__addtitle}>Title</label>
            <input
              id="title"
              type="text"
              name="title"
              value={title}
              onChange={handlechange}
              className={styles.form__inputtitle}
            ></input>
            {formError && <Alert>Title Wajib Diisi</Alert>}
            <label className={styles.form__addyear}>Year</label>
            <input
              id="date"
              type="number"
              name="date"
              value={date}
              onChange={handlechange}
              className={styles.form__inputyear}
            ></input>
            {formError && <Alert>Date Wajib Diisi</Alert>}
            <label className={styles.form__addyear}>Image</label>
            <input
              id="image"
              type="text"
              name="image"
              value={image}
              onChange={handlechange}
              className={styles.form__inputyear}
            ></input>
            {formError && <Alert>Image Wajib Diisi</Alert>}
            <label className={styles.form__addyear}>Genre</label>
            <select
              id="genre"
              value={genre}
              name="genre"
              onChange={handlechange}
              className={styles.form__inputyear}
            >
              <option value="Horor">Horor</option>
              <option value="Comedy">Comedy</option>
              <option value="Romance">Romance</option>
            </select>
            {formError && <Alert>Genre Wajib Dipilih</Alert>}

            <input
              type="submit"
              value="Submit"
              className={styles.form__submit}
            ></input>
          </form>
        </div>
      </section>
    </div>
  );
}

export default AddMovieForm;
